<div class="home2 background-white" style="min-height: 100vh">
    <div>
        <ng-container *ngIf="homePageDataCustomAds && !environmentVariables?.enable_top_ads_on_all_pages">
            <div
                (click)="floatingBannerRouting(0)"
                *ngIf="homePageDataCustomAds[0]?.active === 1"
                class="floating-banner"
                [ngClass]="{ pointer: homePageDataCustomAds[0]?.type == 0 }"
                [ngStyle]="{
                    backgroundColor: homePageDataCustomAds[0]?.dev_key
                }"
            >
                <img  loading="lazy" 
                       alt="mobile Ads"
                    class="mobileAds"
                    [src]="homePageDataCustomAds[0]?.image"
                />
                <img  loading="lazy" 
                       alt="Ads Image"
                    class="webAds"
                    [src]="homePageDataCustomAds[0]?.image_web"
                />
            </div>
        </ng-container>

        <div class="home-skeleton-container" *ngIf="homePageDataAdsShimmer">
            <div class="banner-skeleton-container">
                <div class="light-animate-shimmer image-shimmer"></div>
            </div>
        </div>

        <div
            *ngIf="environmentVariables?.SLIDER_THEME_TYPE == 'pieces'"
            class="home-slider"
        >
            <div class="container">
                <div class="slider-pieces">
                    <div class="col-gal web-view">
                        <img  loading="lazy" 
                            *ngIf="
                                homePageDataCustomAds?.length >= 6 &&
                                homePageDataCustomAds[6]
                            "
                            (click)="
                                homePageDataCustomAds?.length > 6
                                    ? bannerRouting(homePageDataCustomAds[6])
                                    : null
                            "
                            [src]="
                                homePageDataCustomAds?.length > 6
                                    ? homePageDataCustomAds[6]?.image
                                    : './../../../../assets/images/placeholder200.jpg'
                            "
                            onError="this.src='./../../../../assets/images/placeholder200.jpg';"
                               alt="Ad Image"
                        />
                        <img  loading="lazy" 
                            *ngIf="
                                homePageDataCustomAds?.length >= 7 &&
                                homePageDataCustomAds[7]
                            "
                            (click)="
                                homePageDataCustomAds?.length > 7
                                    ? bannerRouting(homePageDataCustomAds[7])
                                    : null
                            "
                            [src]="
                                homePageDataCustomAds?.length > 7
                                    ? homePageDataCustomAds[7]?.image
                                    : './../../../../assets/images/placeholder200.jpg'
                            "
                            onError="this.src='./../../../../assets/images/placeholder200.jpg';"
                               alt="Ad Image"
                        />
                    </div>
                    <div class="slider-gal">
                        <embryo-HomePageTwoSlider
                            *ngIf="homePageDataAds && homePageDataAds?.length"
                            [homePageDataAds]="homePageDataAds"
                            [isRTL]="isDirectionRtl"
                        >
                        </embryo-HomePageTwoSlider>
                    </div>
                    <div class="col-gal web-view">
                        <img  loading="lazy" 
                            *ngIf="
                                homePageDataCustomAds?.length >= 8 &&
                                homePageDataCustomAds[8]
                            "
                            (click)="
                                homePageDataCustomAds?.length > 8
                                    ? bannerRouting(homePageDataCustomAds[8])
                                    : null
                            "
                            [src]="
                                homePageDataCustomAds?.length > 8
                                    ? homePageDataCustomAds[8]?.image
                                    : './../../../../assets/images/placeholder200.jpg'
                            "
                            onError="this.src='./../../../../assets/images/placeholder200.jpg';"
                               alt="Ad Image"
                        />
                        <img  loading="lazy" 
                            *ngIf="
                                homePageDataCustomAds?.length >= 9 &&
                                homePageDataCustomAds[9]
                            "
                            (click)="
                                homePageDataCustomAds?.length > 9
                                    ? bannerRouting(homePageDataCustomAds[9])
                                    : null
                            "
                            [src]="
                                homePageDataCustomAds?.length > 9
                                    ? homePageDataCustomAds[9]?.image
                                    : './../../../../assets/images/placeholder200.jpg'
                            "
                            onError="this.src='./../../../../assets/images/placeholder200.jpg';"
                               alt="Ad Image"
                        />
                    </div>
                </div>
            </div>
        </div>

        <!-- container-swiper -->
        <div
            *ngIf="
                homePageDataAds &&
                homePageDataAds?.length &&
                environmentVariables?.SLIDER_THEME_TYPE != 'pieces'
            "
            [ngClass]="{
                'container':
                    environmentVariables?.SLIDER_THEME_TYPE == 'container'
            }"
        >
            <embryo-HomePageTwoSlider
                [homePageDataAds]="homePageDataAds"
                [isRTL]="isDirectionRtl"
            >
            </embryo-HomePageTwoSlider>
        </div>

        <div
            class="home-skeleton-container"
            *ngIf="homePageDataCustomAdsShimmer"
        >
            <div class="ad-skeleton-container">
                <div class="ad-container">
                    <div class="light-animate-shimmer ad-skeleton"></div>
                </div>
                <div class="ad-container">
                    <div class="light-animate-shimmer ad-skeleton"></div>
                </div>
                <div class="ad-container">
                    <div class="light-animate-shimmer ad-skeleton"></div>
                </div>
                <div class="ad-container">
                    <div class="light-animate-shimmer ad-skeleton"></div>
                </div>
            </div>
        </div>

        <div
            class=" custom-ads-container"
            *ngIf="homePageDataCustomAds?.length > 0"
        >
            <embryo-CtaGroup
                *ngIf="homePageDataCustomAds"
                [homePageDataCustomAds]="
                    homePageDataCustomAds.slice(
                        2,
                        environmentVariables?.SLIDER_THEME_TYPE != 'pieces' &&
                            homePageDataCustomAds?.length > 5
                            ? 10
                            : 6
                    )
                "
                [index]="1"
            >
            </embryo-CtaGroup>
        </div>

        <div *ngIf="environmentVariables?.SLIDER_THEME_TYPE == 'pieces'">
            <div class="mob-view">
                <embryo-CtaGroup
                    *ngIf="homePageDataCustomAds"
                    [homePageDataCustomAds]="
                        homePageDataCustomAds.slice(
                            6,
                            homePageDataCustomAds.length
                        )
                    "
                    [index]="1"
                >
                </embryo-CtaGroup>
            </div>
        </div>

        <div class="container container-category-swiper" 
            *ngIf="environmentVariables?.SHOW_FEATURED_CATEGORIES !== 'mobile'">
            <div class="flex-end view-all-categories" id="view-all-categories">
                <p
                    class="text-inverse mb-0 show-more-btn"
                    tabindex="0"
                    [routerLink]="['/' + lang + '/all-categories']"
                >
                    {{ "home_Page.viewAll" | translate }}
                </p>
            </div>
            <app-categories [isSlider]="true" class=""></app-categories>
        </div>

        <app-home-sections
            [currentPageView]="currentPageViewUrl"
        ></app-home-sections>

        <!-- HOME SECTION -->
        <div class="container">
            <div
                class="flex-end"
                style="position: relative; bottom: -4.3rem"
                *ngIf="brandsList?.length > 0"
            >
                <p
                    class="text-inverse mb-0 show-more-btn"
                    tabindex="0"
                    [routerLink]="['/' + lang + '/brands']"
                >
                    {{ "home_Page.viewAll" | translate }}
                </p>
            </div>

            <app-brands-carousel></app-brands-carousel>
        </div>

        <ng-container *ngIf="homePageDataCustomAds && !environmentVariables?.enable_bottom_ads_on_all_pages">
            <div
                *ngIf="homePageDataCustomAds[1]?.active === 1"
                (click)="floatingBannerRouting(1)"
                class="floating-banner"
                [ngClass]="{ pointer: homePageDataCustomAds[1]?.type == 0 }"
                [ngStyle]="{
                    backgroundColor: homePageDataCustomAds[1]?.dev_key
                }"
            >
                <img  loading="lazy" 
                       alt="Ad Image"
                    class="mobileAds"
                    [src]="homePageDataCustomAds[1]?.image"
                />
                <img  loading="lazy" 
                       alt="Ad Image"
                    class="webAds"
                    [src]="homePageDataCustomAds[1]?.image_web"
                />
            </div>
        </ng-container>
    </div>
</div>
